import { IApplicationState } from '../../types/redux';

export function getAvailableRatings(state: IApplicationState) {
  return state.filters.ratings;
}
